import { createContext } from 'react';
import * as ApiModels from '@/typings/api-models';

type UserProfileContextState = {
  creatorSlug: string;
  creatorId: string | null;
  customStatuses: ApiModels.CustomStatus[] | null;
  setBrowserTabTitle: (title: string | null) => void;
  isInUserProfile: boolean;
};

const UserProfileContext = createContext<UserProfileContextState>({
  creatorId: null,
  creatorSlug: '',
  customStatuses: [],
  isInUserProfile: false,
  setBrowserTabTitle: () => { /* empty */ },
});

export default UserProfileContext;
